export default "__VITE_ASSET__B0EuI5vU__"